import React, { useState } from 'react'
import {
  Box,
  Collapse,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow, Tooltip,
  Typography,
  useTheme
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { Counter } from '../SitesSelection/Sites'

function SelectedSitesRow({ 
  row, 
  subRows = [], 
  accounts,
  hasAccountParentBadge,
  accountParentTooltip
}) {
  const [open, setOpen] = useState(row.count > 2 || accounts > 2 ? false : true)
  const theme = useTheme()
  const {t} = useTranslation()
  return (
    <React.Fragment key={row.id}>
      <TableRow
        sx={{
          cursor: 'pointer',
          height: '40px !important',
          '&.MuiTableRow-root': {
            maxHeight: '32px !important'
          },
          color: open ? 'primary.main' : 'content.primary'
        }}
        onClick={() => setOpen(!open)}>
        <TableCell
          component="td"
          scope="row"
          sx={{
            '&.MuiTableCell-root': {
              height: 'auto !important',
              py: '0',
              border: 'none',
              color: 'inherit'
            }
          }}>
          <Stack direction="row" alignItems="center" gap={1} sx={{ color: 'inherit' }}>
            <IconButton
              size="small"
              sx={{
                width: '20px',
                fontSize: '14px',
                lineHeight: '14px',
                color: 'inherit'
              }}
              onClick={e => {
                e.stopPropagation()
                setOpen(!open)
              }}>
              {!open ? <i className="fa-solid fa-chevron-right" /> : <i className="fa-solid fa-chevron-down" />}
            </IconButton>
            <Typography
              sx={{
                fontSize: '12px',
                lineHeight: '18px',
                fontWeight: 500,
                color: 'inherit',
                whiteSpace: 'nowrap'
              }}>
              {row.label}
            </Typography>
            {hasAccountParentBadge && (
              <Tooltip
                title={typeof accountParentTooltip === 'function' ? accountParentTooltip(row.account) : accountParentTooltip}
                placement={'top'}
                arrow
                sx={{ maxWidth: '40px' }}
              >
                <i className={'fa-regular fa-badge-check'} style={{ color: theme.palette.primary.main, fontSize: 16 }} />
              </Tooltip>
            )}

            <Box sx={{ bgcolor: '#F6F7F8', height: '1px', width: '100%' }} />
          </Stack>
        </TableCell>
        <TableCell
          align="right"
          sx={{
            pr: '14px',
            '&.MuiTableCell-root': {
              height: 'auto !important',
              py: '0',
              border: 'none'
            }
          }}>
          <Box sx={{display: 'flex', justifyContent: 'flex-end'}}>
            <Counter nb={row.count} total={row.nb_children} />
          </Box>
        </TableCell>
        <TableCell
          align="right"
          width={12}
          sx={{
            alignItems: 'center',
            px: 0,
            pr: '4px',
            '&.MuiTableCell-root': {
              height: 'auto !important',
              py: '0',
              border: 'none'
            }
          }}>
          {!row.disabled && (
            <IconButton
              sx={{ fontSize: '16px', color: 'content.dimmed' }}
              onClick={e => {
                e.stopPropagation()
                row.onDelete(row)
              }}>
              <i className="fa-solid fa-circle-xmark"></i>
            </IconButton>
          )}
        </TableCell>
      </TableRow>
      <TableRow
        sx={{
          '&:hover': {
            background: 'inherit'
          }
        }}>
        <TableCell
          sx={{
            padding: 0,
            '&.MuiTableCell-root': {
              height: 'auto !important',
              py: '0',
              border: 'none'
            }
          }}
          colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Table size="small" sx={{ borderCollapse: 'collapse' }} stickyHeader>
                <TableHead sx={{ display: 'none' }}>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {subRows.map((sr, index) => (
                    <TableRow
                      key={sr.id}
                      sx={{
                        height: '32px !important',
                        '&.MuiTableRow-root': {
                          maxHeight: '32px !important'
                        }
                      }}>
                      <TableCell
                        component="td"
                        scope="row"
                        sx={{
                          margin: '0px',
                          py: '0px',
                          pl: '24px',
                          '&.MuiTableCell-root': {
                            height: 'auto !important',
                            py: '0',
                            border: 'none'
                          }
                        }}>
                        <Stack direction="row" alignItems="center" height="32px" gap={1}>
                          {/* Left ligne before label*/}
                          <Stack sx={{ width: '10px', pl: '0px', height: 'inherit' }}>
                            <Box
                              sx={{
                                flex: 1,
                                borderLeft: '1px solid',
                                borderLeftColor: 'border.primary'
                              }}
                            />
                            <Box
                              sx={{
                                flex: 1,
                                ...(index + 1 < subRows.length
                                  ? {
                                      borderLeft: '1px solid',
                                      borderLeftColor: 'border.primary'
                                    }
                                  : {
                                      borderTop: '1px solid',
                                      borderTopColor: 'border.primary'
                                    })
                              }}
                            />
                          </Stack>
                          <Typography
                            sx={{
                              ...(sr.state === 'Etude' && {fontStyle: 'italic'}),
                              fontSize: '14px',
                              lineHeight: '20px',
                              fontWeight: 400,
                              width: '100%'
                            }}>
                            {sr.label}
                          </Typography>
                        </Stack>
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{
                          alignItems: 'center',
                          px: 0,
                          pr: '4px',
                          '&.MuiTableCell-root': {
                            height: 'auto !important',
                            py: '0',
                            border: 'none'
                          }
                        }}>
                        {!sr.disabled && (
                          <IconButton
                            sx={{ fontSize: '16px', color: 'content.dimmed' }}
                            onClick={() => sr.onDelete?.(sr)}>
                            <i className="fa-solid fa-circle-xmark"></i>
                          </IconButton>
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  )
}

export default SelectedSitesRow
